export { default } from "./OwaImage";
export type { OwaImageProps } from "./OwaImage";
